'use strict';

exports.__esModule = true;
exports.asyncSessionStorage = exports.asyncLocalStorage = undefined;

var _asyncLocalStorage = require('./defaults/asyncLocalStorage');

var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var asyncLocalStorage = exports.asyncLocalStorage = (0, _asyncLocalStorage2.default)('local');
var asyncSessionStorage = exports.asyncSessionStorage = (0, _asyncLocalStorage2.default)('session');


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/lib/defaultStorages.js
 ** module id = 653
 ** module chunks = 0
 **/